<template>
    <v-tooltip top>
        <template #activator="data"> 
            <template slot="activator">
                <slot></slot>
            </template>
            <span v-html="text"></span>                                   
        </template>        
    </v-tooltip>  
</template>

<script>
    export default {
        props: {
            text: {
                type:String
            }
        }
    }
</script>

<style scoped>

</style>